import { render, staticRenderFns } from "./ImportLocations.vue?vue&type=template&id=22fe1120"
import script from "./ImportLocations.vue?vue&type=script&lang=js"
export * from "./ImportLocations.vue?vue&type=script&lang=js"
import style0 from "./ImportLocations.vue?vue&type=style&index=0&id=22fe1120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports